import React from 'react'

function About() {
    return (
        <div>
            {/* Hero Section */}
            <section className="ak-about-hero-1">
                <img
                    src="./assets/img/about/bg3.png"
                    className="about-hero-bg ak-bg object-cover"
                    alt="Background"
                    data-swiper-parallax="1152"
                />
                <div className="container">
                    <div className="about-hero-content">
                        <div
                            className="ak-section-heading ak-style-1 animation-title-content animation-style3"
                            style={{ marginLeft: "-25px", marginBottom: "50px" }}
                        >
                            <p
                                className="ak-section-subtitle animation-title"
                                style={{ color: "white", perspective: "400px" }}
                            >
                                About Us
                            </p>
                            <br />
                            <p
                                className="mini-title1"
                                style={{
                                    backgroundColor: "rgb(232, 119, 34)",
                                    color: "white",
                                    padding: "5px 10px",
                                    fontWeight: "bold",
                                    display: "inline-block",
                                    borderRadius: "5px",
                                }}
                            >
                                SEMANTIC Skills Junction
                            </p>
                            <h2
                                className="ak-section-title animation-title"
                                style={{ color: "white", perspective: "400px" }}
                            >
                                World-Class   Training   for   Semiconductor  Industry
                            </h2>
                            <a href="/" className="back-btn" style={{ color: "white" }}>
                                Home / About Us
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Image Section */}
            <div
                className="image-hov-one"
                style={{
                    marginTop: "30px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <img className="img-fluid" src="assets/img/about/ab121.png" alt="About" style={{ backgroundColor: "white" }} />
            </div>

            {/* About Us Content */}
            <section>
                <div className="about-us-content-bg" style={{ marginTop: "20px" }}>
                    <div className="container">
                        <div className="about-us-content">
                            <div className="">
                                <img
                                    className="about-img-1"
                                    src="./assets/img/bg/hm1.png"
                                    alt="About"
                                    style={{
                                        transform: "translate3d(0px, 4.7856px, 0px)",

                                    }}
                                />
                            </div>
                            <div className="info-content">
                                <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
                                    <p className="ak-section-subtitle animation-title" style={{ perspective: "400px" }}>
                                        <span className="split-line" style={{ display: "block", textAlign: "start", position: "relative" }}>
                                            <span style={{ position: "relative", display: "inline-block" }}>
                                                {"About Us".split("").map((char, i) =>
                                                    <span
                                                        key={i}
                                                        style={{
                                                            position: "relative",
                                                            display: "inline-block",

                                                            opacity: 1,
                                                        }}
                                                    >
                                                        {char}
                                                    </span>
                                                )}
                                            </span>
                                        </span>
                                    </p>
                                    <br />
                                    <span style={{ color: "rgb(232, 119, 34)", fontWeight: "bold", fontSize: "17px" }}>SEMANT</span>
                                    <span style={{ color: "rgb(13, 201, 20)", fontWeight: "bold", fontSize: "17px" }}>IC</span> Skills Junction
                                    <h2 className="ak-section-title animation-title" style={{ perspective: "400px" }}>
                                        Empowering India's Semiconductor Workforce
                                    </h2>
                                    <p className="ak-section-desp" style={{ textAlign: "justify" }}>
                                        At SEMANTIC Skills Junction, we are dedicated to addressing the growing global demand for industry-relevant, world-class semiconductor professionals. Our mission is to empower India’s engineers and diploma holders to seamlessly integrate into the global semiconductor workforce and contribute to shaping the future of technology through <strong>
                                            <span style={{ color: "rgb(232, 119, 34)" }}>SEM</span>iconductor <span style={{ color: "rgb(232, 119, 34)" }}>MAN</span>ufacturing <span style={{ color: "rgb(232, 119, 34)" }}>T</span>raining &amp; <span style={{ color: "rgb(13, 201, 20)" }}>I</span>ndustry <span style={{ color: "rgb(13, 201, 20)" }}>C</span>onsultancy
                                        </strong>.
                                    </p>
                                    <ul className="ak-about-us-list" style={{ textAlign: "justify" }}>
                                        <li><strong>Industry-Relevant Training:</strong> Founded to specifically address the need for highly skilled professionals in semiconductor-related fields.</li>
                                        <li><strong>Empowering India’s Workforce:</strong> Our programs are designed to help engineers and diploma holders integrate into the global semiconductor industry.</li>
                                        <li><strong>Leadership Expertise:</strong> With over 100 years of collective experience in semiconductor design and manufacturing, including 18+ years spent at leading overseas manufacturing plants, our leadership team provides unmatched expertise.</li>
                                        <li><strong>Advisory Board:</strong> Our advisory board comprises eminent industry experts from IC Design, Wafer Fab, Facilities Management, and Assembly, ensuring top-tier guidance.</li>
                                        <li><strong>DPIIT Recognition:</strong> We are recognized as a startup by the Department for Promotion of Industry and Internal Trade (DPIIT) under the Ministry of Commerce &amp; Industry, Government of India.</li>
                                        {/* Added Expert Trainers point as requested */}
                                        <li style={{ textAlign: "justify" }}>
                                            <strong>Expert Trainers:</strong> Our Trainers bring a wealth of deep expertise from the semiconductor industry, combining years of hands-on experience with a genuine passion for teaching. With a proven track record of working in leading semiconductor companies, they possess an in-depth understanding of the latest technologies, trends, and best practices shaping the industry. Whether guiding you through complex concepts or offering real-world insights, our trainers ensure that every session is engaging, practical, and tailored to meet the needs of both beginners and experienced professionals. Their commitment to fostering a deeper understanding and sparking curiosity makes them the ideal mentors to help you thrive in the semiconductor field.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="image-hov-one" style={{ marginTop: "30px" }}>
                            <img className="img-fluid" src="assets/img/bg/ld1.png" alt="Leadership" style={{ marginRight: "20px", backgroundColor: "white" }} />
                        </div>
                        <div className="ak-height-125 ak-height-lg-80"></div>
                    </div>
                </div>
            </section>

            {/* Vision, Mission, Goals */}
            <section className="container">
                <div className="feature-content" style={{ marginTop: "-70px" }}>
                    <div className="feature-card">
                        <img className="feature-icon" src="assets/img/icon/light.svg" alt="Vision" />
                        <div className="feature-body">
                            <h5 className="feature-title">Vision</h5>
                            <p style={{ textAlign: "justify" }}>
                                <strong>Empowering Tomorrow's Innovators:</strong> <br />
                                Be India’s leading provider of industry-relevant, world-class Semiconductor and ESDM Training, along with top-tier Industry Consultancy, fostering innovation and technological growth.
                            </p>
                        </div>
                    </div>
                    <div className="ak-feature-hr"></div>
                    <div className="feature-card">
                        <img className="feature-icon" src="assets/img/icon/hand.svg" alt="Mission" />
                        <div className="feature-body">
                            <h5 className="feature-title">Mission</h5>
                            <p style={{ textAlign: "justify" }}>
                                <strong>Going the Extra Mile:</strong> <br />
                                To deliver best-in-class Semiconductor Manufacturing and ESDM Training, equipping individuals with industry-focused skills to meet global technological demands and drive excellence.
                            </p>
                        </div>
                    </div>
                    <div className="ak-feature-hr"></div>
                    <div className="feature-card">
                        <img className="feature-icon" src="assets/img/icon/note.svg" alt="Goals" />
                        <div className="feature-body">
                            <h5 className="feature-title">Goals</h5>
                            <p style={{ textAlign: "justify" }}>
                                <strong>Shaping the Future:</strong> <br />
                                To establish a strong foundation in semiconductor and ESDM education, build strategic industry collaborations, and empower professionals with cutting-edge expertise, ensuring sustainable growth and innovation.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Global Opportunity Section */}
            <section>
                <div className="container" style={{ marginTop: '20px' }}>
                    <div className="testmonial-top-content" style={{ display: 'block' }}>
                        <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
                            <h2
                                className="ak-section-title"
                                style={{ fontSize: '40px', display: 'block' }}
                            >
                                Global Semiconductor Industry: A Growing Opportunity
                            </h2>
                        </div>
                        <div>
                            <p style={{ marginTop: '10px' }}>
                                The semiconductor industry is at the forefront of technological
                                innovation, driving advancements in key areas such as 5G,
                                Artificial Intelligence (AI), Robotics, IoT, Automotive
                                technology, and High-Performance Computing (HPC). Here's an
                                overview of the market's tremendous growth potential
                            </p>
                        </div>
                    </div>

                   <div class="testmonial-content ak-slider ak-slider-testmonial">
                <div class="swiper-wrapper" style={{marginTop:'20px'}}>
                    <div class="swiper-slide">
                        <div class="testmonial-slider">
                            <div class="testmonial-img">
                                <img src="./assets/img/service/s7.png" data-swiper-parallax="200" alt="..." />
                            </div>
                            <div class="testmonial-info">
                                <p class="testmonial-shot-title">
                                India Semiconductor Mission: Empowering the Industry

                                </p>
                                <div class="ak-height-40 ak-height-lg-30"></div>
                                <h3 class="testmonial-title" style={{fontSize:'25px',lineHeight: '1.5'}}>
                                <strong>Program Highlights:</strong> <br/>
      <ul style={{fontSize:'19px', marginLeft:'20px'}}>
        <p>
      <li>Full Prep to start work in Wafer Fabs</li>
        <li>20+ courses structured into 4 modules</li>
        <li>Duration: 100+ hours (3–5 weeks full-time)</li>
        </p>
      </ul>
      <strong>Additional Features:</strong><br/>
      <ul style={{fontSize:'19px', marginLeft:'20px'}}>
        <li>Orientation visit to a Fab Cleanroom</li>
        <li>Includes industry relevant videos</li>
        <li>Delivery Mode: Face-to-Face</li>
      </ul>

                                </h3>
                                <div class="ak-height-50 ak-height-lg-30"></div>
                                {/* <div class="person-info">
                                    <div>
                                        <p class="name">Andrew Taylor</p>
                                        <p class="form">From USA</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="43" height="38" viewBox="0 0 43 38" fill="none">
                        <path
                          d="M19.2291 14.229C19.2291 20.8709 17.6233 26.0703 14.4117 29.8272C11.2 33.5841 6.68822 36.0531 0.876244 37.2343V30.4171C5.28972 29.064 8.25971 26.6176 9.7862 23.078C10.6236 21.3935 10.9863 19.5127 10.8351 17.6376H0.548283L0.548283 0.39867L19.2291 0.39867V14.229ZM42.9883 14.229C42.9883 20.7836 41.4261 25.962 38.3018 29.7642C35.1775 33.5664 30.6221 36.0571 24.6354 37.2363V30.4191C29.0929 29.0193 32.0862 26.6159 33.6154 23.209C34.3942 21.4604 34.7318 19.5472 34.5983 17.6376L24.3075 17.6376V0.39867H42.9883L42.9883 14.229Z"
                          fill="#485B60"
                        />
                      </svg>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    {/* <div class="swiper-slide">
                        <div class="testmonial-slider">
                            <div class="testmonial-img">
                                <img src="./assets/img/bg/bg6.png" data-swiper-parallax="200" alt="..." />
                            </div>
                            <div class="testmonial-info">
                                <p class="testmonial-shot-title">
                                Growing Demand and Key Industry Players
                                </p>
                                <div class="ak-height-40 ak-height-lg-30"></div>
                                <h4 class="testmonial-title" style={{fontSize:'28px'}}>
                              <strong>Additional Features:</strong>
      <ul>
        <li>Orientation visit to a Fab Cleanroom</li>
        <li>Includes industry relevant videos</li>
        <li>Delivery Mode: Face-to-Face</li>
      </ul>
   
                                </h4>
                                <div class="ak-height-50 ak-height-lg-30"></div>
                               
                            </div>
                        </div>
                    </div> */}
                </div>
                <div class="testmonial-controller">
                    {/* <div class="testmonial-swiper-controller">
                        <button class="testmonial-next-btn slider-btn next">
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
                        <button class="testmonial-prev-btn slider-btn prev">
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
                    </div> */}
                    {/* <div>
                        <p class="ak-black-color mb-0 ak-medium">350+ Over</p>
                        <p class="ak-font-16 mb-0">User Feedback</p>
                    </div> */}
                </div>
            </div>
                </div>
            </section>

            {/* Leading Global Investment */}
            <section>
                <div className="container" style={{ marginTop: "20px" }}>
                    <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
                        <h3 className="ak-section-title animation-title" style={{ fontSize: "40px", perspective: "400px" }}>
                            Leading Global Investment
                        </h3>
                        <p className="ak-section-desp" style={{ textAlign: "justify", fontSize: "15px" }}>
                            US Chip companies to hire from overseas as American graduates dwindled and graduate enrolment has shifted toward foreign students. Monthly average salaries in chip manufacturing rose to the highest level in over a decade. US Semiconductor technical workforce gap estimated to be 67,000 by 2030.
                        </p>
                    </div>
                    <div
                        className="image-hov-one"
                        style={{
                            marginTop: "30px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <img className="img-fluid" src="assets/img/about/in.jpeg" alt="Global Investment" />
                    </div>
                </div>
            </section>
            <div className="ak-height-125 ak-height-lg-80"></div>

            {/* Strategic Slider */}
            <section className="container">
                <div className="ak-slider strategic-slider swiper-creative swiper-3d swiper-horizontal swiper-pointer-events swiper-watch-progress">
                    {/* Slide 1 */}
                    <div className="strategic single-card">
                        <div className="strategic-info">
                            <div className="ak-section-heading ak-style-1">
                                <h4 className="ak-section-title" style={{ fontSize: "70px", marginBottom: "40px" }}>
                                    Our Businesses
                                </h4>
                            </div>
                            <div className="ak-height-50 ak-height-lg-30"></div>
                            <p className="title" style={{ fontWeight: "bold", fontSize: "28px", marginBottom: "40px" }}>Why Choose Us?</p>
                            <div className="personalized-long-term">
                                <div className="personalized">
                                    <img className="icon" src="./assets/img/icon/target.svg" alt="Hands-On" />
                                    <h5 className="title" style={{ fontSize: "22px" }}>Hands-On Learning <br /> Experience</h5>
                                    <p className="desp">Practical training programs designed to simulate real-world semiconductor challenges.</p>
                                </div>
                                <div className="personalized-divder"></div>
                                <div className="long-term">
                                    <img className="icon" src="./assets/img/icon/line-chart.svg" alt="Inclusive" />
                                    <h5 className="title" style={{ fontSize: "22px" }}>Inclusive Learning <br />Environment</h5>
                                    <p className="desp">A supportive and collaborative atmosphere that fosters growth and embraces diversity in learning.</p>
                                </div>
                            </div>
                            <div className="ak-height-50 ak-height-lg-30"></div>
                        </div>
                        <div className="strategic-img">
                            <img src="./assets/img/about/aab1.jpeg" alt="Business" data-swiper-parallax="-200" />
                        </div>
                    </div>
                    {/* Slide 2 */}
                    <div className="strategic single-card">
                        <div className="strategic-info">
                            <div className="ak-section-heading ak-style-1">
                                <h3 className="ak-section-title">Position India as a global hub for cutting-edge semiconductor expertise and innovation.</h3>
                            </div>
                            <div className="ak-height-50 ak-height-lg-30"></div>
                            <ul>
                                <li> <strong>Career Advancement</strong> – Open doors to high-growth opportunities in the semiconductor sector.</li>
                                <li> <strong>Practical Training</strong> – Gain real-world exposure through on-job training (OJT) and hands-on sessions.</li>
                                <li><strong>End-to-End Support</strong> – From training to placement assistance, we guide you at every step.</li>
                            </ul>
                            <div className="ak-height-50 ak-height-lg-30"></div>
                        </div>
                        <div className="strategic-img">
                            <img src="./assets/img/about/ab2.png" alt="Innovation" data-swiper-parallax="-200" />
                        </div>
                    </div>
                    <div className="strategic-swiper-controller">
                        {/* Slider Controls could be implemented here */}

                    </div>
                </div>
            </section>

            <span className="ak-scrollup">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z" fill="currentColor" />
                </svg>
            </span>
        </div>

    )
}

export default About
